'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
}

/**
 * Update refinements DOM element
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    updateDom($results, '.refinements');
}

/**
 * Handle pagination update while preserving correct active page
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handlePagination($results) {
    var currentUrl = new URL(window.location.href);
    var startParam = currentUrl.searchParams.get('start');
    var pageParam = currentUrl.searchParams.get('page');
    var pageSize = currentUrl.searchParams.get('sz') || $('.grid-footer').data('page-size') || 12;
    var correctPageNumber = 1;

    if (startParam) {
        correctPageNumber = Math.floor(parseInt(startParam, 10) / parseInt(pageSize, 10)) + 1;
    } else if (pageParam) {
        correctPageNumber = parseInt(pageParam, 10);
    }

    updateDom($results, '.grid-footer');

    $('.grid-footer').attr('data-page-number', correctPageNumber);
    $('.grid-footer').data('page-number', correctPageNumber);

    $('.cc-plp__pagination__link').removeClass('cc-plp__pagination__link--active');

    $('.cc-plp__pagination__link').each(function () {
        var $link = $(this);
        var linkText = $link.text().trim();
        var linkPageNum = parseInt(linkText, 10);

        if (linkPageNum === correctPageNumber) {
            $link.addClass('cc-plp__pagination__link--active');
        }

        var href = $link.attr('href');
        if (href && !isNaN(linkPageNum)) {
            try {
                var linkUrl = new URL(href, window.location.origin);
                currentUrl.searchParams.forEach(function (value, key) {
                    if (key !== 'start' && key !== 'page') {
                        if (linkPageNum === 1) {
                            return;
                        }
                        linkUrl.searchParams.set(key, value);
                    }
                });
                $link.attr('href', linkUrl.pathname + linkUrl.search);
            } catch (err) {
                console.error('Error updating pagination link:', err);
            }
        }
    });

    $('.pagination-arrow--prev, .pagination-arrow--next').each(function () {
        var $arrow = $(this);
        var href = $arrow.attr('href');
        if (href && href !== 'javascript:void(0)') {
            try {
                var arrowUrl = new URL(href, window.location.origin);
                currentUrl.searchParams.forEach(function (value, key) {
                    if (key !== 'start' && key !== 'page') {
                        arrowUrl.searchParams.set(key, value);
                    }
                });
                $arrow.attr('href', arrowUrl.pathname + arrowUrl.search);
            } catch (err) {
                console.error('Error updating arrow link:', err);
            }
        }
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);

    // Capture currently open featured refinement dropdown before DOM updates
    var openDropdownId = null;
    var $openDropdown = $('.cc-featured-refinement-dropdown.show');
    if ($openDropdown.length) {
        openDropdownId = $openDropdown.attr('id');
    }

    // Capture accordion collapse states only (exclude featured refinement dropdowns)
    var openPanelIds = [];
    $('.cc-accordion__collapse.show').each(function () {
        var $collapse = $(this);
        // Only capture accordion panels that are NOT inside featured refinements
        if (!$collapse.closest('.cc-featured-refinement').length) {
            var id = $collapse.attr('id');
            if (id) {
                openPanelIds.push(id);
            }
        }
    });

    var specialHandlers = {
        '.refinements': handleRefinements,
        '.grid-footer': handlePagination
    };

    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.js-button-update-count',
        '.js-filters-btn-wrp'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    // Restore accordion collapse states only (featured refinement dropdowns remain closed)
    openPanelIds.forEach(function (id) {
        var $panel = $('#' + id);
        if ($panel.length && !$panel.hasClass('show')) {
            $panel.addClass('show');

            // Handle accordion panels only
            $panel.siblings('.cc-accordion__header').find('.cc-accordion__btn')
                .attr('aria-expanded', 'true')
                .removeClass('collapsed');
        }
    });

    // Restore the featured refinement dropdown that was open before the update
    if (openDropdownId) {
        var $dropdown = $('#' + openDropdownId);
        if ($dropdown.length) {
            var $button = $('[data-target="#' + openDropdownId + '"]');
            if ($button.length) {
                // Position the dropdown BEFORE making it visible to avoid glimpse
                var buttonRect = $button[0].getBoundingClientRect();
                $dropdown.css({
                    top: buttonRect.bottom + 8 + 'px',
                    left: buttonRect.left + 'px'
                });
                $button.attr('aria-expanded', 'true');
            }
            // Show the dropdown after positioning
            $dropdown.addClass('show');
        }
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Keep selected filter accordion sections open after refresh
 * Note: Featured refinement dropdowns are NOT automatically opened even when filters are selected
 *
 * @return {undefined}
 */
function toggleSelectedFilterAccordion() {
    if ($('.cc-filters .cc-filters__btn.cc-selected').length) {
        // Handle accordion panels only (not featured refinement dropdowns)
        $('.cc-filters .cc-filters__btn.cc-selected').closest('.cc-accordion__item').each(function () {
            var $accordionItem = $(this);
            // Only open if this is NOT inside a featured refinement dropdown
            if (!$accordionItem.closest('.cc-featured-refinement').length) {
                $accordionItem.find('.cc-accordion__btn').attr('aria-expanded', 'true').removeClass('collapsed');
                $accordionItem.find('.cc-accordion__collapse').addClass('show');
            }
        });
    }
}

/**
 * Trigger refinement ajax refresh and history update
 *
 * @param {string} searchUrl - endpoint called by ajax
 * @param {string} seoUrl - url to expose in browser history
 * @param {string} attributeId - optional element id used for focus restore
 * @return {undefined}
 */
function performFilterRequest(searchUrl, seoUrl, attributeId) {
    if (!searchUrl) {
        return;
    }

    try {
        var currentUrl = new URL(window.location.href);
        var currentPageSize = currentUrl.searchParams.get('sz') || $('.grid-footer').data('page-size');

        if (currentPageSize) {
            var searchUrlObj = new URL(searchUrl, window.location.origin);
            var filterPageSize = searchUrlObj.searchParams.get('sz');

            if (filterPageSize && filterPageSize != currentPageSize) {
                searchUrlObj.searchParams.set('sz', currentPageSize);
            }

            searchUrlObj.searchParams.set('start', '0');
            searchUrlObj.searchParams.set('page', '1');
            searchUrl = searchUrlObj.pathname + searchUrlObj.search;

            if (seoUrl) {
                var seoUrlObj = new URL(seoUrl, window.location.origin);
                var seoFilterPageSize = seoUrlObj.searchParams.get('sz');
                if (seoFilterPageSize && seoFilterPageSize != currentPageSize) {
                    seoUrlObj.searchParams.set('sz', currentPageSize);
                }
                seoUrlObj.searchParams.set('start', '0');
                seoUrlObj.searchParams.set('page', '1');
                seoUrl = seoUrlObj.pathname + seoUrlObj.search;
            }
        }
    } catch (err) {
        console.error('Error preserving page size:', err);
    }

    if (seoUrl) {
        window.history.pushState({}, null, seoUrl);
    }

    announceFilterStatus('loading');
    $.spinner().start();
    $.ajax({
        url: searchUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: searchUrl
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            announceFilterStatus('results', getFilterResultCount(response));

            if (!hasNoResults(response)) {
                try {
                    updateSortOptions(response);
                } catch (err) {
                    console.error('Error updating sort options:', err);
                }

                try {
                    var currentUrl = new URL(window.location.href);
                    if (!currentUrl.searchParams.has('srule')) {
                        // Reset to first (default) option
                        var $desktopSelect = $('[name=sort-order]');
                        var $firstOption = $desktopSelect.find('option').first();
                        if ($firstOption.length) {
                            $desktopSelect.val($firstOption.val());
                            if ($desktopSelect.data('selectpicker')) {
                                $desktopSelect.selectpicker('refresh');
                            }
                        }

                        $('.js-sort-mobile-input').prop('checked', false);
                        $('.js-sort-mobile-input').first().prop('checked', true);
                    }
                } catch (err) {
                    console.error('Error resetting sort dropdown:', err);
                }
            }

            $.spinner().stop();
            toggleSelectedFilterAccordion();

            if (attributeId) {
                $(attributeId).parent('button').focus();
            }
        },
        error: function () {
            $.spinner().stop();
            announceFilterStatus('error');

            if (attributeId) {
                $(attributeId).parent('button').focus();
            }
        }
    });
}

/**
 * Parse numeric query parameter from a url
 *
 * @param {string} url - candidate url
 * @param {string} key - query key
 * @return {number} parsed numeric value
 */
function parseNumericQueryParam(url, key) {
    var parsedUrl;

    try {
        parsedUrl = new URL(url, window.location.origin);
    } catch (e) {
        return NaN;
    }

    var rawValue = parsedUrl.searchParams.get(key);

    if (rawValue === null || rawValue === '') {
        return NaN;
    }

    return Number(rawValue.replace(',', '.'));
}

/**
 * Parse a numeric bound from a refinement option data attribute
 *
 * @param {JQuery} $option - price range option node
 * @param {string} key - data key to read
 * @return {number} parsed numeric value
 */
function parseNumericOptionData($option, key) {
    var rawValue = $option.attr('data-' + key);

    if (rawValue === undefined || rawValue === null || rawValue === '') {
        return NaN;
    }

    return Number(String(rawValue).replace(',', '.'));
}

/**
 * Parse numeric bounds from a candidate url
 *
 * @param {string} candidateUrl - candidate url
 * @return {Object|null} parsed bounds
 */
function parsePriceBoundsFromUrl(candidateUrl) {
    var optionMin = parseNumericQueryParam(candidateUrl, 'pmin');
    var optionMax = parseNumericQueryParam(candidateUrl, 'pmax');

    if (isNaN(optionMin) || isNaN(optionMax)) {
        return null;
    }

    return {
        min: optionMin,
        max: optionMax
    };
}

/**
 * Parse global and selected bounds from refinement options
 *
 * @param {JQuery} $options - option nodes collection
 * @return {Object|null} parsed price bounds
 */
function readPriceBoundsFromOptions($options) {
    var bounds = [];
    var selected = null;

    $options.each(function () {
        var $option = $(this);
        var directBounds = {
            min: parseNumericOptionData($option, 'value-from'),
            max: parseNumericOptionData($option, 'value-to')
        };
        var parsedBounds = null;

        if (!isNaN(directBounds.min) && !isNaN(directBounds.max)) {
            parsedBounds = directBounds;
        } else {
            parsedBounds = parsePriceBoundsFromUrl($option.data('url'))
                || parsePriceBoundsFromUrl($option.data('seo-href'));
        }

        if (parsedBounds) {
            bounds.push(parsedBounds);

            if ($option.data('selected') === true || $option.data('selected') === 'true') {
                selected = parsedBounds;
            }
        }
    });

    if (!bounds.length) {
        return null;
    }

    var globalMin = Math.min.apply(null, bounds.map(function (value) {
        return value.min;
    }));
    var globalMax = Math.max.apply(null, bounds.map(function (value) {
        return value.max;
    }));

    var currentUrl = window.location.href;
    var currentMin = parseNumericQueryParam(currentUrl, 'pmin');
    var currentMax = parseNumericQueryParam(currentUrl, 'pmax');

    return {
        min: globalMin,
        max: globalMax,
        selectedMin: !isNaN(currentMin) ? currentMin : (selected ? selected.min : globalMin),
        selectedMax: !isNaN(currentMax) ? currentMax : (selected ? selected.max : globalMax)
    };
}

/**
 * Keep slider and input values in valid range
 *
 * @param {Object} state - range state
 * @return {Object} normalized range state
 */
function normalizePriceRange(state) {
    var normalizedMin = Math.max(state.min, Math.min(state.selectedMin, state.max));
    var normalizedMax = Math.min(state.max, Math.max(state.selectedMax, state.min));

    if (normalizedMin > normalizedMax) {
        normalizedMin = normalizedMax;
    }

    return {
        min: state.min,
        max: state.max,
        selectedMin: normalizedMin,
        selectedMax: normalizedMax
    };
}

/**
 * Update slider progress and textual values
 *
 * @param {JQuery} $component - price range component
 * @param {Object} state - range state
 * @return {undefined}
 */
function syncPriceRangeUi($component, state) {
    var safeState = normalizePriceRange(state);
    var minPercent = ((safeState.selectedMin - safeState.min) / (safeState.max - safeState.min || 1)) * 100;
    var maxPercent = ((safeState.selectedMax - safeState.min) / (safeState.max - safeState.min || 1)) * 100;

    $component.find('.js-price-range-min-slider').attr({
        min: safeState.min,
        max: safeState.max,
        value: safeState.selectedMin
    }).val(safeState.selectedMin);

    $component.find('.js-price-range-max-slider').attr({
        min: safeState.min,
        max: safeState.max,
        value: safeState.selectedMax
    }).val(safeState.selectedMax);

    $component.find('.js-price-range-min-input').attr({
        min: safeState.min,
        max: safeState.max,
        value: safeState.selectedMin
    }).val(safeState.selectedMin);

    $component.find('.js-price-range-max-input').attr({
        min: safeState.min,
        max: safeState.max,
        value: safeState.selectedMax
    }).val(safeState.selectedMax);

    $component.find('.js-price-range-progress').css({
        left: minPercent + '%',
        width: (maxPercent - minPercent) + '%'
    });

    $component.find('.js-price-range-live').text(safeState.selectedMin + ' - ' + safeState.selectedMax);
    $component.data('priceRangeState', safeState);
}

/**
 * Apply price range params while omitting default extrema
 *
 * @param {URL} urlObj - target url object
 * @param {Object} state - price range state
 * @return {undefined}
 */
function applyPriceRangeParams(urlObj, state) {
    var safeState = normalizePriceRange(state);

    if (safeState.selectedMin > safeState.min) {
        urlObj.searchParams.set('pmin', safeState.selectedMin);
    } else {
        urlObj.searchParams.delete('pmin');
    }

    if (safeState.selectedMax < safeState.max) {
        urlObj.searchParams.set('pmax', safeState.selectedMax);
    } else {
        urlObj.searchParams.delete('pmax');
    }
}

/**
 * Build url for current page with selected price range
 *
 * @param {number} selectedMin - min value
 * @param {number} selectedMax - max value
 * @return {string} relative url
 */
function buildPriceRangeUrl(selectedMin, selectedMax) {
    var url = new URL(window.location.href);
    var $priceComponent = $('.js-price-range').first();
    var baseState = $priceComponent.length ? $priceComponent.data('priceRangeState') : null;

    applyPriceRangeParams(url, {
        min: baseState ? baseState.min : selectedMin,
        max: baseState ? baseState.max : selectedMax,
        selectedMin: selectedMin,
        selectedMax: selectedMax
    });
    url.searchParams.delete('start');

    return url.pathname + url.search;
}

/**
 * Initialize a price range component
 *
 * @param {JQuery} $component - component root
 * @return {undefined}
 */
function initPriceRangeComponent($component) {
    var bounds = readPriceBoundsFromOptions($component.find('.js-price-range-option'));

    if (!bounds) {
        return;
    }

    syncPriceRangeUi($component, bounds);
    $component.removeAttr('hidden');

    var $fallbackList = $component.siblings('.js-price-range-fallback');
    $fallbackList.addClass('cc-price-range-fallback--hidden').attr('aria-hidden', 'true');
}

/**
 * Initialize all price range components in current DOM
 *
 * @return {undefined}
 */
function initPriceRangeComponents() {
    $('.js-price-range').each(function () {
        initPriceRangeComponent($(this));
    });
}

// Tracks the last clicked refinement URL while the filter modal is open.
// The full grid request is deferred until the user clicks "Show".
var pendingFilterUrl = null;
var pendingFilterSeoUrl = null;

function announceFilterStatus(state, count) {
    var $status = $('.js-filter-results-status');
    var message;

    if (!$status.length) {
        return;
    }

    if (state === 'loading') {
        message = $status.attr('data-loading-message');
    } else if (state === 'error') {
        message = $status.attr('data-error-message');
    } else {
        message = ($status.attr('data-results-message') || '').replace('{0}', count);
    }

    $status.text(message || '');
}

function getFilterResultCount(response) {
    var $results = $(response);
    var $count = $results.find('.cc-plp__results-count .js-button-update-count, .js-submit-filters .js-button-update-count').first();

    return $count.length ? $count.text().trim() : '0';
}

function captureModalFilterFocus($button) {
    var $refinement = $button.closest('.refinement');

    return {
        refinementId: $refinement.find('.cc-accordion__collapse').attr('id'),
        label: $button.text().trim(),
        originalButton: $button
    };
}

function restoreModalFilterFocus(focusTarget, useOriginalButton) {
    var $button = $();

    if (useOriginalButton) {
        $button = focusTarget.originalButton;
    } else if (focusTarget.refinementId) {
        $('.refinements .refinement').each(function () {
            var $refinement = $(this);
            var refinementId = $refinement.find('.cc-accordion__collapse').attr('id');

            if (refinementId === focusTarget.refinementId) {
                $button = $refinement.find('.cc-filters__btn').filter(function () {
                    return $(this).text().trim() === focusTarget.label;
                }).first();
                return false;
            }
        });
    }

    if ($button.length) {
        $button.trigger('focus');
    } else if (!useOriginalButton) {
        $('#filters .js-submit-filters').trigger('focus');
    }
}

/**
 * Ensure featured refinement dropdowns are closed on page load
 */
$(document).ready(function () {
    $('.cc-featured-refinement-dropdown').removeClass('show');
    $('.cc-featured-refinement [data-toggle="collapse"]').attr('aria-expanded', 'false');
});

/**
 * Update only the refinements panel and result count inside the open filter modal.
 * Does NOT touch the product grid.
 *
 * @param {string} response - Ajax response HTML
 * @return {undefined}
 */
function parseModalResults(response) {
    var $results = $(response);

    var openPanelIds = [];
    $('.cc-accordion__collapse.show').each(function () {
        var $collapse = $(this);
        if (!$collapse.closest('.cc-featured-refinement').length) {
            var id = $collapse.attr('id');
            if (id) {
                openPanelIds.push(id);
            }
        }
    });

    handleRefinements($results);

    // Replace the confirm button's inner content so the product count stays current,
    // including the transition from 0 → N selected filters where the count <span>
    // is conditionally absent from the existing DOM (ISML isif guard).
    var $submitBtn = $results.find('.js-submit-filters');
    if ($submitBtn.length) {
        $('.js-submit-filters').html($submitBtn.html());
    }

    // Re-initialise price range sliders: their DOM nodes were replaced by handleRefinements.
    initPriceRangeComponents();

    // Restore accordion collapse states (keep panels open that were open before)
    openPanelIds.forEach(function (id) {
        var $panel = $('#' + id);
        if ($panel.length && !$panel.hasClass('show')) {
            $panel.addClass('show');

            // Update accordion button state
            $panel.siblings('.cc-accordion__header').find('.cc-accordion__btn')
                .attr('aria-expanded', 'true')
                .removeClass('collapsed');
        }
    });

    // Explicitly close all featured refinement dropdowns in modal
    $('.cc-featured-refinement-dropdown.show').removeClass('show');
    $('.cc-featured-refinement [data-toggle="collapse"]').attr('aria-expanded', 'false');
}

/**
 * Remove price range query parameters from a candidate url
 *
 * @param {string} candidateUrl - candidate url
 * @return {string} sanitized url
 */
function stripPriceRangeParams(candidateUrl) {
    var parsedUrl;

    if (!candidateUrl) {
        return candidateUrl;
    }

    try {
        parsedUrl = new URL(candidateUrl, window.location.origin);
    } catch (e) {
        return candidateUrl;
    }

    parsedUrl.searchParams.delete('pmin');
    parsedUrl.searchParams.delete('pmax');

    return parsedUrl.origin === window.location.origin
        ? parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
        : parsedUrl.toString();
}

/**
 * Check whether an ajax response renders the no-results state
 *
 * @param {string} response - Ajax response HTML
 * @return {boolean} whether the response has no results
 */
function hasNoResults(response) {
    return $(response).find('.cc-plp__no-results').length > 0;
}

/**
 * Refresh modal filters, retrying once without price bounds when the response has no results
 *
 * @param {string} searchUrl - endpoint called by ajax
 * @param {string} seoUrl - seo url paired with the search url
 * @param {Object} focusTarget - filter option focus information
 * @param {boolean} hasRetriedWithoutPrice - whether the fallback retry already ran
 * @param {string} applySearchUrl - final url to keep for the Apply action
 * @param {string} applySeoUrl - final seo url to keep for the Apply action
 * @return {undefined}
 */
function performModalFilterRequest(searchUrl, seoUrl, focusTarget, hasRetriedWithoutPrice, applySearchUrl, applySeoUrl) {
    announceFilterStatus('loading');
    $.ajax({
        url: searchUrl,
        data: { page: $('.grid-footer').data('page-number'), selectedUrl: searchUrl },
        method: 'GET',
        success: function (response) {
            var fallbackSearchUrl;
            var fallbackSeoUrl;

            if (!hasRetriedWithoutPrice && hasNoResults(response)) {
                fallbackSearchUrl = stripPriceRangeParams(searchUrl);
                fallbackSeoUrl = stripPriceRangeParams(seoUrl || searchUrl);

                if (fallbackSearchUrl !== searchUrl || fallbackSeoUrl !== (seoUrl || searchUrl)) {
                    performModalFilterRequest(
                        fallbackSearchUrl,
                        fallbackSeoUrl,
                        focusTarget,
                        true,
                        applySearchUrl || searchUrl,
                        applySeoUrl || seoUrl || searchUrl
                    );
                    return;
                }
            }

            if (hasNoResults(response)) {
                pendingFilterUrl = applySearchUrl || searchUrl;
                pendingFilterSeoUrl = applySeoUrl || seoUrl || searchUrl;
            }

            parseModalResults(response);
            announceFilterStatus('results', getFilterResultCount(response));
            $.spinner().stop();
            // Note: Do NOT call toggleSelectedFilterAccordion() here
            // Modal accordion state is now preserved in parseModalResults()

            if (focusTarget) restoreModalFilterFocus(focusTarget, false);
        },
        error: function () {
            $.spinner().stop();
            announceFilterStatus('error');

            if (focusTarget) restoreModalFilterFocus(focusTarget, true);
        }
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            var sortUrl = this.value;

            try {
                var currentUrl = new URL(window.location.href);
                var sortUrlObj = new URL(sortUrl, window.location.origin);
                var currentPageSize = currentUrl.searchParams.get('sz') || $('.grid-footer').data('page-size');
                var sortPageSize = sortUrlObj.searchParams.get('sz');

                if (currentPageSize && sortPageSize && sortPageSize != currentPageSize) {
                    sortUrlObj.searchParams.set('sz', currentPageSize);
                    sortUrl = sortUrlObj.pathname + sortUrlObj.search;
                }
            } catch (err) {
                console.error('Error preserving page size in sort:', err);
            }

            try {
                var currentUrl = new URL(window.location.href);
                var sortUrlObj = new URL(sortUrl, window.location.origin);

                currentUrl.searchParams.forEach(function (value, key) {
                    // Skip only srule - sz is already handled above
                    if (key !== 'srule') {
                        sortUrlObj.searchParams.set(key, value);
                    }
                });

                sortUrl = sortUrlObj.pathname + sortUrlObj.search;
            } catch (err) {
                console.error('Error merging filter params:', err);
            }

            // Create separate URLs: ShowAjax for AJAX call, Show for browser history
            var ajaxUrl = sortUrl.replace('Search-UpdateGrid', 'Search-ShowAjax');
            var historyUrl = sortUrl.replace('Search-UpdateGrid', 'Search-Show');

            var currentUrlForPage = new URL(window.location.href);
            var startParam = currentUrlForPage.searchParams.get('start');
            var pageParam = currentUrlForPage.searchParams.get('page');
            var currentPageSize = currentUrlForPage.searchParams.get('sz') || $('.grid-footer').data('page-size') || 12;
            var pageNumber = 1;

            if (startParam) {
                pageNumber = Math.floor(parseInt(startParam, 10) / parseInt(currentPageSize, 10)) + 1;
            } else if (pageParam) {
                pageNumber = parseInt(pageParam, 10);
            }

            window.history.pushState({}, null, historyUrl);

            $.spinner().start();
            $(this).trigger('search:sort', ajaxUrl);
            $.ajax({
                url: ajaxUrl,
                data: {
                    selectedUrl: ajaxUrl,
                    page: pageNumber
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    try {
                        updateSortOptions(response);
                    } catch (err) {
                        console.error('Error updating sort options:', err);
                    }
                    $.spinner().stop();

                    if (pageNumber > 1) {
                        var $scrollTarget = $('.cc-plp__region-main');
                        if ($scrollTarget.length) {
                            $('html, body').animate({
                                scrollTop: $scrollTarget.offset().top - 100
                            }, 300);
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $(document).on('click', '.js-sort-mobile-apply', function (e) {
            e.preventDefault();

            const itemValue = $(this).closest('.js-sort-mobile').find('.js-sort-mobile-input:checked').attr('data-value');
            const itemId = $(this).closest('.js-sort-mobile').find('.js-sort-mobile-input:checked').attr('data-id');

            var sortUrl = itemValue;

            try {
                var currentUrl = new URL(window.location.href);
                var sortUrlObj = new URL(sortUrl, window.location.origin);
                var currentPageSize = currentUrl.searchParams.get('sz') || $('.grid-footer').data('page-size');
                var sortPageSize = sortUrlObj.searchParams.get('sz');

                if (currentPageSize && sortPageSize && sortPageSize != currentPageSize) {
                    sortUrlObj.searchParams.set('sz', currentPageSize);
                    sortUrl = sortUrlObj.pathname + sortUrlObj.search;
                }
            } catch (err) {
                console.error('Error preserving page size in sort:', err);
            }

            try {
                var currentUrl = new URL(window.location.href);
                var sortUrlObj = new URL(sortUrl, window.location.origin);

                currentUrl.searchParams.forEach(function (value, key) {
                    // Skip only srule - sz is already handled above
                    if (key !== 'srule') {
                        sortUrlObj.searchParams.set(key, value);
                    }
                });

                sortUrl = sortUrlObj.pathname + sortUrlObj.search;
            } catch (err) {
                console.error('Error merging filter params:', err);
            }

            // Create separate URLs: ShowAjax for AJAX call, Show for browser history
            var ajaxUrl = sortUrl.replace('Search-UpdateGrid', 'Search-ShowAjax');
            var historyUrl = sortUrl.replace('Search-UpdateGrid', 'Search-Show');

            var currentUrlForPage = new URL(window.location.href);
            var startParam = currentUrlForPage.searchParams.get('start');
            var pageParam = currentUrlForPage.searchParams.get('page');
            var currentPageSize = currentUrlForPage.searchParams.get('sz') || $('.grid-footer').data('page-size') || 12;
            var pageNumber = 1;

            if (startParam) {
                pageNumber = Math.floor(parseInt(startParam, 10) / parseInt(currentPageSize, 10)) + 1;
            } else if (pageParam) {
                pageNumber = parseInt(pageParam, 10);
            }

            // Use Show URL for browser history so page can be refreshed
            window.history.pushState({}, null, historyUrl);

            $.spinner().start();
            $(this).trigger('search:sort', ajaxUrl);
            $.ajax({
                url: ajaxUrl,
                data: {
                    selectedUrl: ajaxUrl,
                    page: pageNumber
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    try {
                        updateSortOptions(response);
                    } catch (err) {
                        console.error('Error updating sort options:', err);
                    }
                    $.spinner().stop();

                    if (pageNumber > 1) {
                        var $scrollTarget = $('.cc-plp__region-main');
                        if ($scrollTarget.length) {
                            $('html, body').animate({
                                scrollTop: $scrollTarget.offset().top - 100
                            }, 300);
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    $('body').trigger('search:updateDom', '.grid-footer');
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .cc-filters__btn, .js-reset-filters, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;
                var attributeId = '#' + $(this).find('span').last().attr('id');
                var isReset = $(this).hasClass('js-reset-filters');
                var isModalOpen = $('#filters').hasClass('show') || $('#filters').hasClass('in');
                var isFilterRemoval = $(this).closest('.filter-value').length > 0 ||
                    $(this).hasClass('cc-selected') ||
                    $(this).find('.cc-selected').length > 0;

                // Remove sorting when filter is removed/reset or when deselecting a refinement
                if (isReset || isFilterRemoval) {
                    try {
                        var searchUrlObj = new URL(searchUrl, window.location.origin);
                        searchUrlObj.searchParams.delete('srule');
                        searchUrl = searchUrlObj.pathname + searchUrlObj.search;

                        if (seoUrl) {
                            var seoUrlObj = new URL(seoUrl, window.location.origin);
                            seoUrlObj.searchParams.delete('srule');
                            seoUrl = seoUrlObj.pathname + seoUrlObj.search;
                        }

                        setTimeout(function () {
                            var $desktopSelect = $('[name=sort-order]');
                            var $firstOption = $desktopSelect.find('option').first();
                            if ($firstOption.length) {
                                $desktopSelect.val($firstOption.val());
                                if ($desktopSelect.data('selectpicker')) {
                                    $desktopSelect.selectpicker('refresh');
                                }
                            }

                            $('.js-sort-mobile-input').prop('checked', false);
                            $('.js-sort-mobile-input').first().prop('checked', true);
                        }, 100);
                    } catch (err) {
                        console.error('Error removing sort param:', err);
                    }
                }

                // Inside modal: only refresh refinements + count; full grid update is deferred to Submit.
                // Reset always fires immediately since it clears all pending state.
                if (!isReset && isModalOpen) {
                    pendingFilterUrl = searchUrl;
                    pendingFilterSeoUrl = seoUrl;

                    $.spinner().start();
                    performModalFilterRequest(searchUrl, seoUrl, captureModalFilterFocus($(this)), false, searchUrl, seoUrl);
                } else {
                    // Outside modal or Reset: apply immediately
                    pendingFilterUrl = null;
                    pendingFilterSeoUrl = null;
                    performFilterRequest(searchUrl, seoUrl, attributeId);
                }
            }
        );
    },

    priceSlider: function () {
        initPriceRangeComponents();

        $('.container').off('input.priceRange change.priceRange keydown.priceRange');

        $('.container').on('input.priceRange', '.js-price-range-min-slider, .js-price-range-max-slider', function () {
            var $component = $(this).closest('.js-price-range');
            var state = $component.data('priceRangeState');

            if (!state) {
                return;
            }

            if ($(this).hasClass('js-price-range-min-slider')) {
                state.selectedMin = Number($(this).val());
            } else {
                state.selectedMax = Number($(this).val());
            }

            syncPriceRangeUi($component, state);
        });

        $('.container').on('change.priceRange', '.js-price-range-min-slider, .js-price-range-max-slider, .js-price-range-min-input, .js-price-range-max-input', function () {
            var $component = $(this).closest('.js-price-range');
            var state = $component.data('priceRangeState');

            if (!state) {
                return;
            }

            state.selectedMin = Number($component.find('.js-price-range-min-input').val());
            state.selectedMax = Number($component.find('.js-price-range-max-input').val());
            syncPriceRangeUi($component, state);
        });

        $('.container').on('keydown.priceRange', '.js-price-range-min-input, .js-price-range-max-input', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                // Sync state only; actual submit is triggered by the "Show" button
                $(this).trigger('change');
            }
        });

        $('body').off('search:updateDom.priceRange').on('search:updateDom.priceRange', function (event, selector) {
            if (selector === '.refinements') {
                initPriceRangeComponents();
            }
        });
    },

    submitFilters: function () {
        // "Show" button: commit all pending changes (regular filters + price slider) in one request
        $('body').on('click', '.js-submit-filters', function () {
            var $priceComponent = $('.js-price-range').first();
            var priceState = $priceComponent.length ? $priceComponent.data('priceRangeState') : null;

            // Base: last pending filter URL (Ajax) and SEO URL (Search-Show), or current page
            var baseUrl = pendingFilterUrl || window.location.href;
            var baseSeoUrl = pendingFilterSeoUrl || window.location.href;
            var submitUrl = baseUrl;
            var submitSeoUrl = baseSeoUrl;

            // Overlay the current price slider values on top of whatever refinements are selected
            if (priceState) {
                try {
                    var urlObj = new URL(baseUrl, window.location.origin);
                    applyPriceRangeParams(urlObj, priceState);
                    urlObj.searchParams.delete('start');
                    submitUrl = urlObj.pathname + urlObj.search;
                } catch (err) {
                    submitUrl = baseUrl;
                }
                try {
                    var seoUrlObj = new URL(baseSeoUrl, window.location.origin);
                    applyPriceRangeParams(seoUrlObj, priceState);
                    seoUrlObj.searchParams.delete('start');
                    submitSeoUrl = seoUrlObj.pathname + seoUrlObj.search;
                } catch (err) {
                    submitSeoUrl = baseSeoUrl;
                }
            }

            // Clear pending state before async call
            pendingFilterUrl = null;
            pendingFilterSeoUrl = null;

            // Skip if nothing actually changed.
            // Normalise both sides to relative paths before comparing because
            // submitUrl may be an absolute URL when no price slider is present.
            var currentRelative = window.location.pathname + window.location.search;
            var submitUrlRelative = submitUrl;
            try {
                var urlForComp = new URL(submitUrl, window.location.origin);
                submitUrlRelative = urlForComp.pathname + urlForComp.search;
            } catch (e) { /* keep as is */ }
            if (submitUrlRelative === currentRelative) {
                return;
            }

            performFilterRequest(submitUrl, submitSeoUrl);
        });

        // Discard pending state when modal is closed without submitting (X / backdrop)
        $('body').on('hidden.bs.modal', '#filters', function () {
            pendingFilterUrl = null;
            pendingFilterSeoUrl = null;
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    pagination: function () {
        // Handle pagination link clicks with AJAX
        $('.container').on('click', '.cc-plp__pagination__link, .pagination-arrow--prev, .pagination-arrow--next', function (e) {
            var href = $(this).attr('href');

            // Skip if disabled or invalid
            if (!href || href === 'javascript:void(0)' || $(this).hasClass('cc-plp__pagination__link--active') || $(this).hasClass('cc-plp__pagination__arrow--disabled')) {
                e.preventDefault();
                return;
            }

            e.preventDefault();

            // Use the server-computed Ajax URL (includes site alias / locale path).
            var ajaxUrl = $(this).attr('data-ajax-url');

            // Get page number from URL for ajax data
            var pageNumber = 1;
            try {
                var urlForPage = new URL(href, window.location.origin);
                var startParam = urlForPage.searchParams.get('start');
                var pageParam = urlForPage.searchParams.get('page');
                var pageSize = urlForPage.searchParams.get('sz') || $('.grid-footer').data('page-size') || 12;

                if (startParam) {
                    pageNumber = Math.floor(parseInt(startParam, 10) / parseInt(pageSize, 10)) + 1;
                } else if (pageParam) {
                    pageNumber = parseInt(pageParam, 10);
                }
            } catch (err) {
                console.error('Error calculating page number:', err);
            }

            window.history.pushState({}, null, href);

            $.spinner().start();
            $.ajax({
                url: ajaxUrl,
                method: 'GET',
                data: {
                    selectedUrl: ajaxUrl 
                },
                success: function (response) {
                    parseResults(response);
                    updateSortOptions(response);
                    $.spinner().stop();

                    var $scrollTarget = $('.cc-plp__region-main');
                    if ($scrollTarget.length) {
                        $('html, body').animate({
                            scrollTop: $scrollTarget.offset().top - 100
                        }, 300);
                    }
                },
                error: function () {
                    $.spinner().stop();
                    window.location.href = href;
                }
            });
        });
    },

    featuredRefinementDropdowns: function () {
        // Close all featured refinement dropdowns on page load/init
        $('.cc-featured-refinement-dropdown').removeClass('show');
        $('.cc-featured-refinement [data-toggle="collapse"]').attr('aria-expanded', 'false');

        // Position dropdown relative to button using fixed positioning
        function positionDropdown($button, $dropdown) {
            var buttonRect = $button[0].getBoundingClientRect();
            $dropdown.css({
                top: buttonRect.bottom + 8 + 'px',
                left: buttonRect.left + 'px'
            });
        }

        // Check if button is more than 60% out of view
        function isButtonMostlyHidden($button) {
            var $filterBar = $('.filter-bar');
            if (!$filterBar.length) return false;

            var buttonRect = $button[0].getBoundingClientRect();
            var filterBarRect = $filterBar[0].getBoundingClientRect();

            // Calculate visible portion of button
            var visibleLeft = Math.max(buttonRect.left, filterBarRect.left);
            var visibleRight = Math.min(buttonRect.right, filterBarRect.right);
            var visibleWidth = Math.max(0, visibleRight - visibleLeft);
            var buttonWidth = buttonRect.width;

            // If button width is 0, consider it hidden
            if (buttonWidth === 0) return true;

            var visiblePercentage = (visibleWidth / buttonWidth) * 100;

            // Return true if less than 40% visible (more than 60% hidden)
            return visiblePercentage < 40;
        }

        // Close dropdowns for buttons that are mostly hidden
        function closeHiddenDropdowns() {
            $('.cc-featured-refinement-dropdown.show').each(function () {
                var $dropdown = $(this);
                var $button = $('[data-target="#' + $dropdown.attr('id') + '"]');
                if ($button.length && isButtonMostlyHidden($button)) {
                    $dropdown.removeClass('show');
                    $button.attr('aria-expanded', 'false');
                }
            });
        }

        // Handle featured refinement dropdown toggle
        $('body').on('click', '.cc-featured-refinement [data-toggle="collapse"]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $button = $(this);
            var targetId = $button.data('target');
            var $targetDropdown = $(targetId);
            var isCurrentlyOpen = $targetDropdown.hasClass('show');

            // Close all other open dropdowns
            $('.cc-featured-refinement-dropdown.show').not($targetDropdown).each(function () {
                $(this).removeClass('show');
                var $otherButton = $('[data-target="#' + $(this).attr('id') + '"]');
                $otherButton.attr('aria-expanded', 'false');
            });

            // Toggle current dropdown
            if (!isCurrentlyOpen) {
                positionDropdown($button, $targetDropdown);
                $targetDropdown.addClass('show');
                $button.attr('aria-expanded', 'true');
            } else {
                $targetDropdown.removeClass('show');
                $button.attr('aria-expanded', 'false');
            }
        });

        // Reposition dropdowns and close hidden ones on scroll within filter-bar
        $('.filter-bar').on('scroll', function () {
            $('.cc-featured-refinement-dropdown.show').each(function () {
                var $dropdown = $(this);
                var $button = $('[data-target="#' + $dropdown.attr('id') + '"]');
                if ($button.length) {
                    if (isButtonMostlyHidden($button)) {
                        $dropdown.removeClass('show');
                        $button.attr('aria-expanded', 'false');
                    } else {
                        positionDropdown($button, $dropdown);
                    }
                }
            });
        });

        $(window).on('scroll resize', function () {
            closeHiddenDropdowns();
            $('.cc-featured-refinement-dropdown.show').each(function () {
                var $dropdown = $(this);
                var $button = $('[data-target="#' + $dropdown.attr('id') + '"]');
                if ($button.length && !isButtonMostlyHidden($button)) {
                    positionDropdown($button, $dropdown);
                }
            });
        });

        // Close dropdowns when clicking outside
        $(document).on('click', function (e) {
            var $target = $(e.target);

            // Check if click is outside featured refinement area
            if (!$target.closest('.cc-featured-refinement').length) {
                $('.cc-featured-refinement-dropdown.show').each(function () {
                    $(this).removeClass('show');
                    var $button = $('[data-target="#' + $(this).attr('id') + '"]');
                    $button.attr('aria-expanded', 'false');
                });
            }
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    }
};
